import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing, Tween } from '@tweenjs/tween.js';
import { AwaitIterators } from '../AnimationHelper';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import Point from '../../../Utility/Point';
import TransformComponent from '../../../Component/Transform';
import { delay } from '../../../Utility/Task/TaskQueue';

export interface UIPopInParams {
    scale?: Point;
    startDelay?: number;
    endDelay?: number;
    duration?: number;
}

export class UIPopIn extends AnimationClip<UIPopInParams | undefined> {
    public *execute(
        gameObject: GameObject,
        meta?: UIPopInParams
    ): IterableIterator<number> {
        const {
            duration = 450,
            scale = Point.One,
            startDelay,
            endDelay,
        } = meta || ({} as UIPopInParams);

        const renderable = gameObject.getComponent<Renderable>(Renderable);
        renderable.visible = true;
        renderable.alpha = 1;

        this.setScale(gameObject, new Point(0, 0));

        const scaleTween = this.getScaleTween(gameObject, scale, duration);
        const alphaTween = this.getTween(renderable);

        alphaTween.to({ alpha: 1 }, duration / 3).easing(Easing.Linear.None);

        if (startDelay) {
            yield* delay(startDelay);
        }
        yield* AwaitIterators([
            this.startTween(alphaTween),
            this.startTween(scaleTween),
        ]);
        if (endDelay) {
            yield* delay(endDelay);
        }
    }

    private getScaleTween(
        gameObject: GameObject,
        scale: Point,
        duration: number
    ): Tween {
        const component:
            | ElementComponent
            | TransformComponent = gameObject.hasComponent(ElementComponent)
            ? gameObject.getComponent(ElementComponent)
            : gameObject.getComponent(TransformComponent);

        return this.getTween(component.scale)
            .to({ x: scale.x, y: scale.y }, duration)
            .easing(Easing.Back.Out);
    }

    private setScale(gameObject: GameObject, scale: Point): void {
        const component:
            | ElementComponent
            | TransformComponent = gameObject.hasComponent(ElementComponent)
            ? gameObject.getComponent(ElementComponent)
            : gameObject.getComponent(TransformComponent);
        component.scale.copy(scale);
    }
}
